// extracted by mini-css-extract-plugin
export var currencyInput = "_np-1";
export var currencySymbol = "_np-0";